import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { getDraftOrderBadgeLabel } from '../helpers/OrderHelper';

const defaultStyles = StyleSheet.create({
  badge: {
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 1,
    marginLeft: 6,
    alignSelf: 'center',
  },
  text: {
    color: '#fff',
    fontSize: 10,
    fontWeight: 'bold',
  },
});

export default function DraftOrderBadge({ order, style }) {
  if (!order.is_draft) return null;
  return (
    <View style={[defaultStyles.badge, style]}>
      <Text style={defaultStyles.text}>{getDraftOrderBadgeLabel(order)}</Text>
    </View>
  );
}
